import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { TermAndConditionListComponent } from './term-and-condition-list/term-and-condition-list.component';
import { TermAndConditionEditComponent } from './term-and-condition-edit/term-and-condition-edit.component';
import { EditorModule } from '@progress/kendo-angular-editor';

@NgModule({
  declarations: [
    TermAndConditionListComponent,
    TermAndConditionEditComponent
  ],
  imports: [
    SharedModule,
    EditorModule
  ]
})
export class TermAndConditionModule { }
